import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, HostListener, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { PortadaService } from 'src/app/services/portada.service';
import { ProductoService } from 'src/app/services/producto.service';
import { GLOBAL } from 'src/app/services/GLOBAL';
import { GaleriaService } from 'src/app/services/galeria.service';
import { ColorService } from 'src/app/services/color.service';
import { SelectorService } from 'src/app/services/selector.service';
import { ComentarioService } from 'src/app/services/comentario.service';
import { UserService } from 'src/app/services/user.service';
import { CarritoService } from 'src/app/services/carrito.service';
import { ProvinciaService } from 'src/app/services/provincia.service';
import { CitaService } from "../../services/cita.service";
import { PopUpService } from '../../services/popUp.service';

declare let tns;
// import * as io from "socket.io-client";
import { MarcaService } from 'src/app/services/marca.service';
import { CategoriaService } from 'src/app/services/categoria.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { LocationService } from "../../services/location.service";

declare let countdown;


declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class InicioComponent implements OnInit, AfterViewInit {
  @ViewChild('materials')
  materialsSection: ElementRef;

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;

  public identity;
  public best_sellers: Array<any> = [];
  public url;
  public selectores: Array<any> = [];
  public galeria: Array<any> = [];
  public colores: Array<any> = [];
  public first_img;
  public select_producto;
  // public socket = io('http://34.68.74.165:4201');

  public cinco_estrellas = 0;
  public cuatro_estrellas = 0;
  public tres_estrellas = 0;
  public dos_estrellas = 0;
  public una_estrella = 0;

  public cinco_porcent = 0;
  public cuatro_porcent = 0;
  public tres_porcent = 0;
  public dos_porcent = 0;
  public uno_porcent = 0;
  public raiting_porcent = 0;
  public total_puntos = 0;
  public max_puntos = 0;
  public raiting_puntos = 0;
  public comentarios: Array<any> = [];

  public color_to_cart;
  public cantidad_to_cart = 1;
  public precio_to_cart;
  public selector_to_cart = ' ';
  public err_stock = '';
  public selector_error = false;
  public marcas: Array<any> = [];

  public promocion: any = {};
  public categorias;
  public categoriaLatest;
  public productoLatest;

  public locations: Array<any> = [];
  public provincias: Array<any> = [];

  public productos_best_sellers: Array<any> = [];
  public productos_newest: Array<any> = [];
  public productos_populares: Array<any> = [];

  public sliders: Array<any> = [];
  public headers = false;

  public news_productos: [];
  public portada: any = {};
  private materials = false;
  public over = [];
  public extensionLists = {
    video: ['m4v', 'avi', 'mpg', 'mp4', 'webm'],
    image: ['jpg', 'gif', 'bmp', 'png', 'webp']
  };

  public desktopFileType = 'image';
  public mobileFileType = 'image';
  public heroDesktopLoaded = false;
  public heroMobileLoaded = false;
  
  public global = GLOBAL;
  public locationsPerProvincia: { [id: string]: any[] } = {};
  public isLoaded = false;
  public locationsToShow: Array<any> = [];
  public provinciasToShow: Array<any> = [];
  public servicios: Array<any> = [];
  public selectedServicio: any;
  public dateSelected: any;
  public tomorrow: any;
  public places: Array<any> = [];
  public placeSelected: any;
  public errorAgenda: any;
  public agendaSelected: any;
  public citaSelected: any;
  public nombrePaciente: any;
  public cedulaPaciente: any;
  public correoPaciente: any;
  public sexoPaciente: any;
  public telefonoPaciente: any;
  public errorCita: any;
  public confirmacionCita: any;
  public isMobile = false;
  public isDesktop = false;
  public savedPopUp: any;
  public showPopup = false;



  constructor(
    private _route: ActivatedRoute,
    private _productoService: ProductoService,
    private _portadaService: PortadaService,
    private _galeriaService: GaleriaService,
    private _colorService: ColorService,
    private _selectorService: SelectorService,
    private _userSerice: UserService,
    private _carritoService: CarritoService,
    private _marcaService: MarcaService,
    private _categoriaService: CategoriaService,
    private _router: Router,
    private _formBuilder: UntypedFormBuilder,
    private _locationService: LocationService,
    private _provinciaService: ProvinciaService,
    private _citaService: CitaService,
    private metaTagService: Meta,
    private _popUpService: PopUpService,
    private cdr: ChangeDetectorRef
  ) {
    this.url = GLOBAL.url;
    this.identity = this._userSerice.getIdentity();
  }

  ngOnInit(): void {
    this._popUpService.getLocalPopUp().subscribe(
      response => {
        this.savedPopUp = response;
        this.cdr.detectChanges();
      }
    );

    if (window.screen.width <= 600) { // 768px portrait
      this.isMobile = true;
      this.isDesktop = false;
    } else {
      this.isMobile = false;
      this.isDesktop = true;
    }

    this.initData();

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required],
    });

    this.listar_newest();
    this._productoService.best_seller().subscribe(
      response => {
        this.best_sellers = response.data;
      }
    );

    this.get_marcas();

    this.listar_latest();

    this.get_portada();


    this._productoService.best_seller().subscribe(
      response => {
        this.productos_best_sellers = response.data;
      }
    );


    this._productoService.populares().subscribe(
      response => {
        this.productos_populares = response.data;
      },
      error => {

      }
    );

    var today = new Date();
    var tomorrowDate = new Date();
    tomorrowDate.setDate(today.getDate());
    this.tomorrow = tomorrowDate.toISOString().split('T')[0];

    this.metaTagService.addTags([
      { name: 'keywords', content: 'Clínica médica,Servicios médicos,Odontología,Oftalmología,Cirugías,Barato,Economía de la salud,COVID-19,Atención médica,Consultas especializadas,Tratamientos personalizados,Equipo médico experto,Innovación en salud,Tecnología médica avanzada,Bienestar del paciente,Calidad de atención,Experiencia del paciente,Ortodoncia,Brackets,Aparatos dentales,Estética dental,Salud bucal,Opciones de financiamiento,Planes de pago,flexibles,Seguro médico,Consulta gratuita,Diagnóstico preciso,Cirugía láser,Recuperación rápida,Atención integral,Terapia,Rehabilitación postoperatoria,Prevención de enfermedades,Promoción de la salud,Bienestar integral,Medicina preventiva,Tratamientos no invasivos,Rehabilitación visual,Lentes correctivos,Cirugía refractiva,Control de la miopía,Oftalmólogo especializado,anteojos,doctor,Farmacia,Medicina,Cumplimiento normativo,Innovación tecnológica,Investigación médica,Optica,Compromiso,Comodidad,Accesibilidad,Consejos de salud,Planes de prevención,Atención personalizada,Profesionales de confianza,Tecnología de vanguardia,Cirugía mínimamente invasiva,Tiempos de recuperación reducidos,Rehabilitación integral,Atención domiciliaria,Seguridad del paciente,Descuentos especiales,Promociones,Frenillos,Paquetes de servicios,Economía,Eficiencia,Ahorro,Financiamiento accesible,Económico,positivo,Valor agregado,Planes de pago,Oftalmologo,Cirujano,Diente,Dientes,Sonrisa,Licencia de conducir,Incapacidad,Vista,Sonrisa,Higado,Caries,Odontólogo,Clínica dental,Salud bucal,Tratamientos dentales,Higiene oral,Blanqueamiento dental,Implantes dentales,Endodoncia,Ortodoncia,Carillas dentales,Prótesis dentales,Extracciones dentales,Periodoncia,Cuidado preventivo,Emergencias dentales,Odontología estética,Sedación dental,Odontopediatría,Rehabilitación oral,Atención personalizada,Cirugía general,Cirugía,Cirugía laparoscópica,Cardiologia,cardíaca,Cirugía ortopédica,Cirugía de urgencia,Optometría,Examen de la vista,Gafas,Lentes de contacto,Monturas,Graduación,Optometrista,Tienda de óptica,Lentes progresivos,Lentes bifocales,Lentes monofocales,Lentes fotocromáticos,Lentes anti-reflejo,Lentes polarizados,Lentes de seguridad,Lentes deportivos,Lentes para computadora,Lentes para lectura,Lentes para niños,Lentes de sol,Protección UV,Armazones,Garantía de calidad,Asesoramiento especializado,Síntomas de gripe,Tratamiento para la gripe,Remedios caseros para la gripe,Causas de la gripe,Prevención de la gripe,Vacuna contra la gripe,Contagio de la gripe,Complicaciones de la gripe,Diagnóstico de la gripe,Virus de la gripe,Epidemiología de la gripe,Estacionalidad de la gripe,Gripe estacional,Gripe común,Influenza,Resfriado vs gripe,Diferencias entre resfriado y gripe,Gripe y embarazo,Gripe y niños,Gripe y ancianos,Tratamiento natural para la gripe,Medicamentos para la gripe,Complicaciones de la gripe en niños,Cuidados durante la gripe,Alivio de los síntomas de la gripe,Gripe y sistema inmunológico,Gripe y fiebre,Gripe y tos,Gripe y dolor de cabeza,Gripe y malestar general,Gripe' }
    ]);

    // Verificar si el pop-up ya ha sido mostrado o cerrado en esta sesión
    const popupClosed = sessionStorage.getItem('popupClosed');
    if (!popupClosed) {
      this.setupScrollListener();
    }

  }

  ngAfterViewInit(): void {
    // Configurar un intervalo para hacer clic cada 11000 ms
    setInterval(() => {
      const desktopNextButton = document.querySelector('#portadaamagdesktop .carousel-control-next');
      const mobileNextButton = document.querySelector('#portadaamagmobile .carousel-control-next');

      // Simular clic en los botones de siguiente si existen
      if (desktopNextButton) {
        desktopNextButton.dispatchEvent(new Event('click'));
      }
      if (mobileNextButton) {
        mobileNextButton.dispatchEvent(new Event('click'));
      }
    }, 11000);

    // Suscripción a los parámetros de la ruta para desplazarse a la sección de materiales si es necesario
    this._route.params.subscribe(params => {
      if (params.subplace && params.subplace === 'materiales') {
        this.materialsSection.nativeElement.scrollIntoView();
      }
    });
}


  get_portada() {
    this._portadaService.get_data().subscribe(
      response => {
        this.portada = response.imagenes || {};
        this.setHeroInitialLoadState();

        if (this.portada.tipo === 'Portada') {
          const desktopExtension = this.getFileExtension(this.portada.portada);
          const mobileExtension = this.getFileExtension(this.portada.portadaMobile);

          if (this.extensionLists.video.includes(desktopExtension)) {
            this.desktopFileType = 'video';
          } else {
            this.desktopFileType = 'image';
          }

          if (this.extensionLists.video.includes(mobileExtension)) {
            this.mobileFileType = 'video';
          } else {
            this.mobileFileType = 'image';
          }
        }
      },
      error => {
        console.error("Error al obtener los datos de portada", error);
      }
    );
  }

  private hasValidMedia(fileName: any): boolean {
    return typeof fileName === 'string' && fileName.trim().length > 0;
  }

  private getFileExtension(fileName: any): string {
    if (!this.hasValidMedia(fileName)) {
      return '';
    }

    const extension = fileName.split('.').pop();
    return extension ? extension.toLowerCase() : '';
  }

  private setHeroInitialLoadState(): void {
    if (!this.portada || !this.portada.tipo) {
      this.heroDesktopLoaded = true;
      this.heroMobileLoaded = true;
      return;
    }

    if (this.portada.tipo === 'Portada') {
      this.heroDesktopLoaded = !this.hasValidMedia(this.portada.portada);
      this.heroMobileLoaded = !this.hasValidMedia(this.portada.portadaMobile);
      return;
    }

    if (this.portada.tipo === 'Slider') {
      this.heroDesktopLoaded = ![
        this.portada.slider1,
        this.portada.slider2,
        this.portada.slider3,
        this.portada.slider4,
        this.portada.slider5,
      ].some(slide => this.hasValidMedia(slide));

      this.heroMobileLoaded = ![
        this.portada.slider1Mobile,
        this.portada.slider2Mobile,
        this.portada.slider3Mobile,
        this.portada.slider4Mobile,
        this.portada.slider5Mobile,
      ].some(slide => this.hasValidMedia(slide));
      return;
    }

    this.heroDesktopLoaded = true;
    this.heroMobileLoaded = true;
  }

  onHeroMediaLoaded(device: 'desktop' | 'mobile'): void {
    if (device === 'desktop') {
      this.heroDesktopLoaded = true;
      return;
    }

    this.heroMobileLoaded = true;
  }


  ngOnDestroy() {
    // Asegurarse de eliminar el listener de scroll cuando el componente se destruya
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  setupScrollListener() {
    window.addEventListener('scroll', this.onWindowScroll);
  }

  onWindowScroll = () => {
    if (this.savedPopUp.encendido) {
      this.showPopup = true;
      sessionStorage.setItem('popupShown', 'true');
      window.removeEventListener('scroll', this.onWindowScroll);
    }
  }

  closePopup() {
    this.showPopup = false;
    sessionStorage.setItem('popupClosed', 'true'); // Marcar que el pop-up ha sido cerrado
  }

  verPromocion() {
    // Lógica para ver la promoción
    console.log('Ver Promoción');
    this.closePopup();
  }
  /*  listarServicios() {

      this._citaService.listarServicios().subscribe(
        response => {
          this.servicios = response.servicios;
        }
      );
    }

    listarAgenda() {
      if (this.selectedServicio && this.dateSelected) {
        var data = {
          fecha_inicio : this.dateSelected.toLocaleString("es-CL").split(' ')[0] + ' 00:00:00',
          fecha_fin : this.dateSelected.toLocaleString("es-CL").split(' ')[0] + ' 23:59:59',
          servicio: this.selectedServicio.key
        }
        this._citaService.listarAgenda(data).subscribe(
          response => {
            this.places = response.agenda;
          },
          error => {
            this.errorAgenda = error;
          }
        );
      }
      else {
        this.errorAgenda = "Elija servicio y fecha"
      }
    }*/


  data_countdown(fecha) {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;


    let countDown = new Date(fecha).getTime(),
      x = setInterval(function () {

        let now = new Date().getTime(),
          distance = countDown - now;

        $('#count_dias').text(Math.floor(distance / (day))),
          $('#count_horas').text(Math.floor((distance % (day)) / (hour))),
          $('#count_min').text(Math.floor((distance % (hour)) / (minute))),
          $('#count_seg').text(Math.floor((distance % (minute)) / second));


      }, second);
  }

  get_color(event, color) {
    this.color_to_cart = color.color;

  }

  click_img(img, id) {

    $('.cz-thumblist-item.active').removeClass('active');
    $('#' + id).addClass('active');
    this.first_img = img;

  }


  add_to_cart(carritoForm) {
    /*    if(this.cantidad_to_cart > this.select_producto.stock){
          this.err_stock = 'La cantidad no debe superar al stock';
        }
        else if(this.cantidad_to_cart <= 0){
          this.err_stock = 'La cantidad no puede ser un valor negativo';
        }
        else{
          this.err_stock = '';*/
    let data = {
      // user: this.identity._id,
      producto: this.select_producto,
      cantidad: this.cantidad_to_cart,
      color: this.color_to_cart,
      selector: this.selector_to_cart,
      precio: this.select_producto.precio_ahora
    };
    if (this.selector_to_cart != ' ') {
      this.selector_error = false;
      this._carritoService.registro(data).subscribe(
        response => {
          // this.socket.emit('save-carrito', {new:true});

        },
        error => {


        }
      );
    } else {
      this.selector_error = true;
    }
    // }

  }

  get_marcas() {
    this._marcaService.listar('').subscribe(
      response => {
        this.marcas = response.marcas;

      },
      error => {

      }
    );
  }

  get_galeria(item) {
    this.galeria = [];
    this.select_producto = item;


    this._galeriaService.find_by_product(item._id).subscribe(
      response => {
        this.data_colores(item._id);
        this.data_selectores(item._id);
        this.err_stock = '';
        this.selector_error = false;
        this.color_to_cart;
        this.cantidad_to_cart = 1;
        this.precio_to_cart;
        this.selector_to_cart = ' ';
        response.galeria.forEach((element, index) => {
          if (index == 0) {
            this.first_img = element.imagen;
          }
          this.galeria.push({ _id: element._id, imagen: element.imagen });
        });
      },
      error => {


      }
    );
  }

  data_colores(id) {
    this._colorService.listar(id).subscribe(
      response => {
        this.colores = response.colores;
        this.color_to_cart = this.colores[0].color;


      },
      error => {

      }
    );
  }

  data_selectores(id) {
    this._selectorService.listar(id).subscribe(
      response => {
        this.selectores = response.selectores;

      },
      error => {

      }
    );
  }



  listar_latest() {
    this._categoriaService.listarLatest().subscribe(
      response => {
        this.categoriaLatest = response.categoria;
        this._productoService.listar_cat(this.categoriaLatest._id).subscribe(
          response => {
            this.productoLatest = response.productos;
            this.over = new Array(this.productoLatest.length);
            this.over.fill(false);
          },

          error => {

          }
        );
      },
      error => {

      }
    );
  }

  listar_newest() {
    this._productoService.listar_newest().subscribe(
      response => {
        this.news_productos = response.data;
        this.over = new Array(this.news_productos.length);
        this.over.fill(false);
      },
      error => {

      }
    );
  }



  initData() {
    this.isLoaded = false;
    this.locationsPerProvincia = {};
    this._provinciaService.listar().subscribe(
      response_prov => {
        this.provincias = response_prov.provincia;
        for (var provincia of this.provincias) {
          this.locationsPerProvincia[provincia.name] = [];
        }
        this._locationService.listar().subscribe(
          response => {
            this.locations = response.location;
            for (var local of this.locations) {
              this.locationsPerProvincia[local.provincia.name].push(local)
            }
            this.provinciasToShow = [];
            for (var prov of this.provincias) {
              if (this.locationsPerProvincia[prov.name].length != 0) {
                this.provinciasToShow.push(prov)
              }
            }
            this.isLoaded = true;
          },
          error => {
          }
        );
      },
      error => {
      }
    );

  }

  selectProvincia(key) {
    this.locationsToShow = this.locationsPerProvincia[key];
  }


  selectTime() {

  }

  debug() {
    var t = 0;
  }

  gtagSendEvent(phoneNumber: string): boolean {
    const callback = () => {
      window.location.href = phoneNumber;
    };

    (window as any).gtag('event', 'conversion_event_phone_call_lead', {
      'event_callback': callback,
      'event_timeout': 2000,
      // Puedes agregar más parámetros del evento aquí
    });

    return false;
  }

  // Método para manejar el click del enlace
  onPhoneCallClick(event: Event, phoneNumber: string) {
    event.preventDefault(); // Prevenir el comportamiento por defecto del enlace
    this.gtagSendEvent(phoneNumber);
  }
}
